import { render, staticRenderFns } from "./CompanyNotWorking.vue?vue&type=template&id=48e381d9"
import script from "./CompanyNotWorking.vue?vue&type=script&lang=js"
export * from "./CompanyNotWorking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports